import { render } from "./login.vue?vue&type=template&id=0c98a22e&scoped=true"
import script from "./login.vue?vue&type=script&lang=js"
export * from "./login.vue?vue&type=script&lang=js"

import "./login.vue?vue&type=style&index=0&id=0c98a22e&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/akc-mallrobot-akc-dz-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c98a22e"]])

export default __exports__